var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTgYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social_tg_yellow",
    transform: "translate(1.000000, 1.000000)",
    fill: "#D4AF37",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C13.9706,0 18,4.029442 18,9 C18,13.970602 13.9706,18 9,18 C4.02944,18 0,13.970602 0,9 C0,4.029442 4.02944,0 9,0 Z M9,0.818182 C4.48131016,0.818182 0.818182,4.48131072 0.818182,9 C0.818182,13.5187175 4.48129435,17.181818 9,17.181818 C13.5187313,17.181818 17.181818,13.5187318 17.181818,9 C17.181818,4.48129635 13.5187155,0.818182 9,0.818182 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07426,8.904962 C6.69794,7.761872 8.44747,7.008272 9.3229,6.644172 C11.8223,5.604582 12.3416,5.423992 12.6801,5.41791087 C12.7546,5.416722 12.921,5.435172 13.0289,5.522672 C13.1199,5.596552 13.145,5.696352 13.157,5.766402 C13.1689,5.836452 13.1839,5.996022 13.172,6.120702 C13.0366,7.543812 12.4505,10.997302 12.1523,12.591202 C12.0262,13.265702 11.7778,13.491802 11.5373,13.514002 C11.0146,13.562002 10.6178,13.168602 10.1115,12.836702 C9.3194,12.317502 8.87193,11.994302 8.10305,11.487602 C7.21446,10.902002 7.79049,10.580202 8.2969,10.054202 C8.42942,9.916602 10.7322,7.821982 10.7768,7.631972 C10.7824,7.608212 10.7875,7.519632 10.7349,7.472852 C10.6823,7.426082 10.6046,7.442082 10.5486,7.454802 C10.4691,7.472832 9.2037,8.309222 6.75232,9.964002 C6.39313,10.210602 6.06779,10.330802 5.7763,10.324502 C5.45496,10.317602 4.83681,10.142802 4.37729,9.993402 C3.81366,9.810202 3.3657,9.713402 3.40471,9.402202 C3.42503,9.240102 3.64821,9.074392 4.07426,8.904962 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTgYellow);
export default __webpack_public_path__ + "static/media/social_tg_yellow.a2ba7eff.svg";
export { ForwardRef as ReactComponent };